// Types
import type {
	TStepperOrientation,
	TStepperPosition, TStepperProps,
	TStepperStatus,
	TStepperTextPosition,
	TStepProps
} from './Stepper.type';

export const STEP_DISPLAY_NAME = 'Step';

export const STEPPER_TEXT_POSITIONS: TStepperTextPosition[] = ['top', 'bottom', 'left', 'right'];
export const STEPPER_TEXT_POSITION: { [key in TStepperTextPosition]: key } = {
	top: 'top',
	bottom: 'bottom',
	left: 'left',
	right: 'right',
}

export const STEPPER_ORIENTATIONS: TStepperOrientation[] = ['horizontal', 'vertical'];
export const STEPPER_ORIENTATION: { [key in TStepperOrientation]: key } = {
	horizontal: 'horizontal',
	vertical: 'vertical',
}

export const STEPPER_POSITIONS: TStepperPosition[] = ['start', 'middle', 'end']
export const STEPPER_POSITION: { [key in TStepperPosition]: key } = {
	start: 'start',
	middle: 'middle',
	end: 'end'
}

export const STEPPER_STATUSES: TStepperStatus[] = ['default', 'active', 'complete']
export const STEPPER_STATUS: { [key in TStepperStatus]: key } = {
	default: 'default',
	active: 'active',
	complete: 'complete'
}

export const STEP_DEFAULT_PROPS: TStepProps = {
	orientation: STEPPER_ORIENTATION.horizontal,
	position: STEPPER_POSITION.start,
	status: STEPPER_STATUS.default,
	textPosition: STEPPER_TEXT_POSITION.bottom,
}

export const STEPPER_DEFAULT_PROPS: Omit<TStepperProps, 'children'> = {
	activeStep: 0,
	orientation: STEPPER_ORIENTATION.horizontal,
	textPosition: STEPPER_TEXT_POSITION.bottom,
}
